import TrackingJS from "@vp/tracking"
import React from "react"
import { buildAnalyticsMetaData } from "../utils/tracking"

export default class Analytics extends React.Component {
  render() {
    return <></>
  }

  async componentDidMount() {
    TrackingJS.initWithData(this.props.trackingConfig)
    const tracking = TrackingJS.getTracking()

    this.sendPageTracking(tracking)
  }

  sendPageTracking(tracking) {
    tracking.page(
      buildAnalyticsMetaData({
        pageName: this.props.pageName,
        pageSection: this.props.pageSection,
        genTrack: "Gatsby",
        languageLocale: this.props.locale,
      })
    )
  }
}
